<template>
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs v-if="fill === 'gradient'">
      <linearGradient
        id="gradient"
        x1="22.4602"
        y1="0.0996092"
        x2="7.57649"
        y2="22.0373"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#FF00D6" />
        <stop offset="1" stop-color="#0072DB" />
      </linearGradient>
    </defs>
    <path
      d="M22.6995 18L13.5995 8.90001C14.4995 6.60001 13.9995 3.90001 12.0995 2.00001C10.0995 1.20401e-05 7.09945 -0.399988 4.69945 0.700012L8.99945 5.00001L5.99945 8.00001L1.59945 3.70001C0.399451 6.10001 0.899451 9.10001 2.89945 11.1C4.79945 13 7.49945 13.5 9.79945 12.6L18.8995 21.7C19.2994 22.1 19.8995 22.1 20.2994 21.7L22.5995 19.4C23.0995 19 23.0995 18.3 22.6995 18Z"
      :fill="fill === 'gradient' ? 'url(#gradient)' : fill"
    />
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: "black",
    },
  },
};
</script>
